import React from 'react';
import { ArticleCard } from './ArticleCard';
import { PlusButton } from './PlusButton';
import { SectionHeader } from './SectionHeader';
export function SpecialReport() {
  return <section className="w-full relative" style={{
    marginTop: '37px'
  }} data-id="element-277">
      {/* INSIGHTS badge */}
      <SectionHeader label="Insights" data-id="element-278" />

      {/* Background image area */}
      <div className="relative w-full md:h-[472px]" style={{
      marginTop: '-16px',
      paddingBottom: '40px'
    }} data-id="element-279">
        {/* Background image */}
        <img src="https://cdn.magicpatterns.com/uploads/wzThEQAKYAAkwne4hcdEap/Rectangle_87_(1).png" alt="" className="absolute inset-0 w-full h-full object-cover" style={{
        zIndex: 0
      }} data-id="element-280" />

        {/* Dark overlay */}
        <div className="absolute inset-0" style={{
        background: 'rgba(0, 0, 0, 0.45)',
        zIndex: 1
      }} data-id="element-281" />

        {/* Text content */}
        <div className="relative site-container flex flex-col items-center" style={{
        zIndex: 2,
        paddingTop: '90px'
      }} data-id="element-282">
          {/* SPECIAL REPORT label */}
          <span style={{
          color: '#FFF',
          textAlign: 'left',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '18.75px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
          letterSpacing: '1.875px',
          textTransform: 'uppercase' as const
        }} data-id="element-283">
            Special Report
          </span>

          {/* Title + Description wrapper — keeps description aligned with title's left edge */}
          <div style={{
          maxWidth: '800px',
          marginTop: '16px'
        }} data-id="element-284">
            <h2 style={{
            color: '#FFF',
            fontFamily: "'League Gothic', Impact, Arial, sans-serif",
            fontSize: '65px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '65px',
            textAlign: 'left'
          }} data-id="element-285">
              The US agencies storming up the World Creative Rankings
            </h2>

            <p style={{
            color: '#FFF',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
            textAlign: 'left',
            marginTop: '16px',
            maxWidth: '700px'
          }} data-id="element-286">
              Special Group, a global independent creative network, was the
              year's biggest climber in North America.
            </p>
          </div>
        </div>
      </div>

      {/* Article cards — overlapping the background */}
      <div className="relative site-container mt-6 md:-mt-[120px]" style={{
      zIndex: 3
    }} data-id="element-287">
        <div className="relative" style={{
        maxWidth: '1040px',
        margin: '0 auto'
      }} data-id="element-288">
          <div className="w-full grid grid-cols-1 md:grid-cols-3" style={{
          gap: '37px'
        }} data-id="element-289">
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/hmd8RTg2dhqgufNWoSEJMx/Rectangle_41.png" title="Mazda and Disney Are Big Winners at Oscars With Cinematic Ad Takeover" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-290" />
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/fyT1wVaYT9WKKJQgDtrP5M/Rectangle_42.png" title="Disney Are Big Winners at Oscars With Cinematic Ad Takeover" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-291" />
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/iFm4zkS1U82HqEHJNgBYw2/Rectangle_52.png" title="Dubai Culture launches Ramadan-themed animated series 'Badr Al Musahar'" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-292" />
          </div>
          <div className="absolute -right-3 lg:-right-5 top-[25%] hidden md:block" data-id="element-293">
            <PlusButton size="sm" data-id="element-294" />
          </div>
        </div>
      </div>
    </section>;
}